
@switch (columnId) {
  @case (ReportFileOrderByEnum.Id) {
    <lib-text-table-column>
      {{ element.id }}
    </lib-text-table-column>
  }
  @case (ReportFileOrderByEnum.FullName) {
    <lib-text-table-column>
      {{ element.fullName }}
    </lib-text-table-column>
  }
  @case (ReportFileOrderByEnum.FileType) {
    <lib-text-table-column>
      {{ element.fileType | spaceBetweenCaps }}
    </lib-text-table-column>
  }
  <!--
  <ng-container *ngSwitchCase="ReportFileOrderByEnum.Owner">
    <lib-text-table-column>
      {{ element.owner }}
    </lib-text-table-column>
  </ng-container>
  -->
  @case (ReportFileOrderByEnum.CreatedUtc) {
    <lib-date-time-label [dateUtc]="element.createdUtc"></lib-date-time-label>
  }
  @case (ReportFileOrderByEnum.UpdatedUtc) {
    <lib-date-time-label [dateUtc]="element.updatedUtc"></lib-date-time-label>
  }
  @case (ReportFileOrderByEnum.Status) {
    <lib-status-chip
      class="report-file-statuses"
      [status]="element.status">
    </lib-status-chip>
  }
  @case ('reprocess') {
    <lib-vitu-tooltip text="Reprocess">
      <i class="far fa-redo global-table-cell-image-link" (click)="onClickReprocess()"></i>
    </lib-vitu-tooltip>
  }
  @case ('download') {
    <lib-vitu-tooltip text="Download">
      <i class="far fa-file-download global-table-cell-image-link" (click)="onClickDownload()"></i>
    </lib-vitu-tooltip>
  }
  @default {
  }
}
